export enum Methodology {
    Waterfall = "Waterfall",
    Agile = "Agile",
    Scrum = "Scrum",
    TDD = "Test-Driven Development",
    CI = "Continuous Integration",
    CD = "Continuous Development",
    Solid = "SOLID"
}
